const initTabsSections = () => {
  const tabsSectionEls = document.querySelectorAll('[data-tabs-section]');
  if (!tabsSectionEls.length) return;

  const toggleContent = (tabEls, currentTab, currentTabIndex, contentEls) => {
    tabEls.forEach((tab) => {
      tab.classList.remove('bg-ghost', 'border-ghost');
      tab.setAttribute('aria-selected', 'false');
    });
    currentTab.classList.add('bg-ghost', 'border-ghost');
    currentTab.setAttribute('aria-selected', 'true');
    contentEls.forEach((content) => content.classList.add('hidden'));
    contentEls[currentTabIndex].classList.remove('hidden');
  };

  tabsSectionEls.forEach((section) => {
    const tabEls = section.querySelectorAll('[data-tabs-tab]');
    const contentEls = section.querySelectorAll('[data-tabs-content]');
    if (!tabEls.length || !contentEls.length) return;

    tabEls.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        toggleContent(tabEls, tab, index, contentEls);
      });
    });
  });
};

export default initTabsSections;
